import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { EorderApiService } from '../services/eorder.api.service';

export const productFieldNamesTranslationGuard: CanActivateFn = async () => {
	const router = inject(Router);
	const eorderApiService = inject(EorderApiService);
	try {
		await firstValueFrom(eorderApiService.loadConfigurationFieldNames());
		return true;
	} catch (err) {
		console.error('unable to load configuration field names', err);
		return router.createUrlTree(['/']);
	}
};
